import type { App } from 'vue';
import { LDPlugin } from 'launchdarkly-vue-client-sdk';

export function initializeLaunchDarkly(app: App) {
  return new Promise<void>((resolve) => {
    app.use(LDPlugin, {
      clientSideID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
    });

    resolve();
  });
}
